import { useMutation } from 'react-query';

import { postV2ApiCompanyIdWalletWithdrawals } from 'src/client/spendesk-api';

import { type WireFundsOutBankInformationDetails } from '../types';

type WireFundsOutPayload = {
  companyId: string;
  accountId: string;
  accountDetails: WireFundsOutBankInformationDetails;
  amount: {
    value: number;
    currency: string;
  };
};

export const useWireFundsOutRequestForCompany = () => {
  return useMutation(async (payload: WireFundsOutPayload) => {
    const response = await postV2ApiCompanyIdWalletWithdrawals({
      path: {
        companyId: payload.companyId,
      },
      body: {
        amount: payload.amount,
        beneficiaryDetails: {
          ...payload.accountDetails,
          ...payload.accountDetails.details,
        },
      },
    });
    if (response.statusCode !== 202) {
      throw new Error('Failed to request wire funds out');
    }
    return response.body;
  });
};
